import { Container } from '../../component'

export const MainScreen = () => {

  return (
    <main>
      <Container>
        main screen - aqui haverá a lista paginada de pokémons
      </Container>
    </main>
  )
}
